const calculateTotalNotApplicableQuestions = (questionnaires) => {
  const notApplicableQuestions = questionnaires.map(
    (questionnaire) => questionnaire.notApplicableQuestions,
  )

  return notApplicableQuestions.reduce((sum, current) => sum + current, 0)
}

export default calculateTotalNotApplicableQuestions
